<script>

export default {
    data() {
        return {
            data: {},
        };
    },
    mounted() {
        var vm = this;

        vm.load();
    },
    methods: {
        load() {
            var vm = this;

            vm.newData();
            vm.create();
        },
        newData() {
            var vm = this;

            var data = {
                store: 0,
                reservation: 0,
                permission_id: null,
            };

            vm.data = Object.assign({}, data);
        },
        async create() {
            var vm = this;

            this.$loading.on('config_general_user_create');
            try {
                var resp = await this.$api.ConfigUser.get();
                var data = resp.data.data;

                vm.data = data;

                this.$loading.off('config_general_user_create');
            } catch (err) {
                this.$flash.error(err.response.data.message);
            }
        },
        async submit() {
            var vm = this;
            this.$loading.on('config_general_user_submit');

            try {
                var postData = vm._createPostData(vm.data);
                var resp = await this.$api.ConfigUser.create(postData);

                var data = resp.data;

                vm.create();

                this.$flash.success(data.message);
            } catch (err) {
                this.$flash.error(err.response.data.message);
            }
            this.$loading.off('config_general_user_submit');
        },
        _createPostData: function (data) {

            return data;
        },
        fetchPermission: async function (params) {
            const resp = await this.$api.PermissionGroup.all(params)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        }
    }
};
</script>

<template>
    <BRow class="justify-content-center">
        <BCol lg="12">
            <b-form @submit="submit()">
                <BCard no-body>
                    <BCardBody>
                        <loading :loading="$loading.get('config_general_user_create')" variant="dark" type="block">
                            <BRow>
                                <BCol lg="4 mb-3">
                                    <label class="form-label">{{ $t('config_general.label.store')
                                        }}</label>
                                    <div class="input-group">
                                        <input type="number" v-model="data.store" class="form-control" id="email"
                                            :placeholder="$t('config_general.placeholder.store')" />
                                        <span class="input-group-text" id="basic-addon2">{{ $t('basic.label.row')
                                            }}</span>
                                    </div>
                                </BCol>
                                <BCol lg="4 mb-3">
                                    <label class="form-label">{{ $t('config_general.label.reservation')
                                        }}</label>
                                    <div class="input-group">
                                        <input type="number" v-model="data.reservation" class="form-control" id="email"
                                            :placeholder="$t('config_general.placeholder.reservation')" />
                                        <span class="input-group-text" id="basic-addon2">/{{ $t('basic.label.day')
                                            }}</span>
                                    </div>
                                </BCol>
                                <BCol class="mb-3" lg="4">
                                    <label for="choices-publish-status-input" class="form-label">{{
                                        $t('user.label.permission')
                                        }}</label>
                                    <dynamic-select v-model="data.permission_id"
                                        :placeholder="$t('user.label.permission')"
                                        :loadOptions="fetchPermission"/>
                                </BCol>
                            </BRow>
                        </loading>
                    </BCardBody>
                    <BCardFooter v-if="$ac.hasAccess('config_general_create')">
                        <div class="hstack gap-2 justify-content-end">
                            <BButton type="submit" variant="success" class="w-sm"
                                :disabled="$loading.get('config_general_user_submit')">
                                <loading :loading="$loading.get('config_general_user_submit')" variant="light"
                                    type="button">
                                    <i class="mdi mdi-floppy me-1"></i>
                                    {{ $t('basic.btn.save') }}
                                </loading>
                            </BButton>
                        </div>
                    </BCardFooter>
                </BCard>
            </b-form>
        </BCol>
    </BRow>
</template>